import * as Msal from '@azure/msal-browser'
import config from '../msal/config'

export default {
  mounted () {
    this.applicationConfig = {
      clientId: config.clientid,
      authority: config.authority,
      redirectUri: config.redirecturl
    }
    this.app = new Msal.PublicClientApplication({auth: this.applicationConfig})
    this.app.initialize().then(() => {
      this.app.handleRedirectPromise().then(this.handleResponse).catch(err => {
        console.log('error intilizing MSAl Promise', err)
      })
    })
  },

  data () {
    return {
      app: null
    }
  },
  methods: {
    async loginRedirect () {
      const loginRequest = {
        scopes: ['openid', 'profile', 'User.Read']
      }
      await this.app.loginRedirect(loginRequest)
    },
    async handleResponse (resp) {
      if (resp !== null) {
        const {accessToken, account: {username}} = resp
        const {redirect_to: redirectUrl} = this.$route.query
        const payload = {authData: {username, accessToken}, redirectpath: redirectUrl}
        this.$store.dispatch('ssoLogin', payload)
      } else {
        const loginRequest = {
          scopes: ['openid', 'profile', 'User.Read']
        }
        await this.app.loginRedirect(loginRequest)
      }
    }

  }

}



// WEBPACK FOOTER //
// ./src/services/msal-autologin/index.js